import { IllustrationType, Loader } from '@diana/core';
import { IconButton, Stack, Tooltip, useTheme } from '@mui/material';

export interface IRightDrawerAction {
  icon: IllustrationType;
  onClick: (event: React.MouseEvent<HTMLButtonElement>) => void;
  hidden?: boolean;
  disabled?: boolean;
  isLoading?: boolean;
  tooltip?: string;
}

interface IRightDrawerActionsProps {
  actions: IRightDrawerAction[];
}

export const RightDrawerActions = ({ actions }: IRightDrawerActionsProps) => {
  const { palette } = useTheme();
  const buttonSize = 32;
  const iconSize = 20;
  const buttonStyles = { width: buttonSize, height: buttonSize };
  const iconStyles = { width: iconSize, height: iconSize };

  return (
    <Stack direction="row" alignItems="center" gap={0.25}>
      {actions.map((action, index) => {
        const {
          icon: Icon,
          onClick,
          hidden = false,
          disabled = false,
          isLoading = false,
          tooltip,
        } = action;
        if (hidden) return null;

        return (
          <Tooltip key={`right-drawer-header-action-${index}`} title={tooltip}>
            {isLoading ? (
              <Stack alignItems="center" justifyContent="center" style={buttonStyles}>
                <Loader simple progressProps={{ size: iconSize }} />
              </Stack>
            ) : (
              <IconButton disabled={disabled} onClick={onClick} style={buttonStyles}>
                <Icon
                  style={{
                    ...iconStyles,
                    color: disabled ? palette.text.disabled : palette.text.secondary,
                  }}
                />
              </IconButton>
            )}
          </Tooltip>
        );
      })}
    </Stack>
  );
};
